import type { OrchestratorSchemas } from '@ctcells/contract'

import { orchestrator } from '../clients.ts'
import { keys } from '../keys.ts'
import { createQuery, type SkippableArgs } from '../query.ts'

/**
 * 걸린 것 목록 — `GET /safety/stops`(`IFC-RO-109` · v0.9.4 · 2026-10-08 신설).
 *
 * 실물(`ctcells-core/app/views/stops.py` · `services/stops.py` · dev2 2026-10-11 `{"items": [], "alarms_open": 31}`)
 *
 * | 칸 | 값 |
 * | --- | --- |
 * | 역할 | **가르지 않는다**(`require_roles(ROLES)` — viewer 포함 · 「왜 멈췄나」는 보는 사람이 먼저 묻는다) |
 * | 응답 | `StopsList{items: StopItem[], alarms_open}` — 쪽 나눔 없음. 실서버 스펙의 200 스키마는 빈 `object` 라 생성 타입(정본)을 쓴다 |
 * | 쓰기 | 없다(계산 전용) |
 *
 * 🔴 **종전 `GET /resource-locks`(자원 점유)를 대신한다.** 서버가 v0.9.4 에서 그 경로를 걷고 격리·보류·비상정지를
 *    이 한 창구로 모았다.
 * 🔴 **`said` 는 서버가 지은 문장이다 — 화면은 그대로 그린다.** `kind`·`target` 으로 문장을 다시 짓지 않는다.
 * 🔴 **`releasable` 은 서버 판정이다.** 화면이 `kind` 로 「풀 수 있다」를 추론하지 않는다.
 * ⚠ 열린 알람은 항목이 아니다(원칙 «알람은 알림이다») — `alarms_open` 건수만 온다.
 *
 * 갱신: 안전·모듈 사건뿐 아니라 batch_status에서도 무효화한다(격리 생성/해제, 폴링 없음).
 * ⚠ 쿼리 키는 `keys.safety.stops()` 다 — `keys.safety.all()` 무효화(안전 해제 · 비상정지)에 같이 빠진다.
 */
export type StopItem = OrchestratorSchemas['schemas']['StopItem']
export type StopsList = OrchestratorSchemas['schemas']['StopsList']

export const useStops = createQuery<SkippableArgs | void, StopsList>({
  key: () => keys.safety.stops(),
  fetch: () =>
    orchestrator.request<StopsList>({ method: 'GET', path: '/safety/stops', retryOn401: true }),
})
